import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AtivoService } from "app/auxiliares/services/ativo-service";
import { BaseComponent } from "app/base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { UsuarioService } from "app/base-module/base-service/usuario.service";
import { ClienteService } from "app/clientes/services/cliente.service";
import { EscritorioService } from "app/empreendimento/services/escritorio.service";
import { Escritorio } from "app/empresas/models/escritorio.model";
import { Usuario } from "app/usuarios/models/user.model";
import { map, Observable } from "rxjs";

export interface DialogData {
    id: number;
}

interface IAtivo {
    id: number;
    nome: string;
    sigla: string;
}

interface ICliente {
    id: number;
    nome: string;
    numero_xp: string;
}

@Component({
    selector: "app-filtra-basket-ativo",
    templateUrl: "./filtra-basket-ativo.component.html",
    styleUrls: ["./filtra-basket-ativo.component.scss"],
    providers: [ClienteService, EscritorioService, AtivoService],
})
export class FiltraBasketAtivoComponent extends BaseComponent {
    cliente = new FormControl("");
    ativo = new FormControl("");
    assessor_id = new FormControl("");
    escritorio_id = new FormControl("");

    model: any = {
        escritorio_id: "",
    };

    loadingSpinner!: boolean;
    loadingSpinnerAtivos!: boolean;
    loadingSpinnerAssessor: boolean = false;
    loadingSpinnerEscritorio: boolean = false;

    filteredOptions!: Observable<ICliente[]>;
    filteredOptionsAtivo!: Observable<IAtivo[]>;
    listAssessor: Usuario[] = [];
    listEscritorios: Escritorio[] = [];
    listAtivos: any[] = [];
    usuario: any;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltraBasketAtivoComponent, { static: false })
    table!: FiltraBasketAtivoComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltraBasketAtivoComponent>,
        private _clienteService: ClienteService,
        private _ativoService: AtivoService,
        private usuarioService: UsuarioService,
        private _authService: AuthService,
        public escritorioService: EscritorioService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);

        const strUser = this._authService.getUser();
        this.usuario = JSON.parse(strUser ? strUser : "{}");

        this.cliente.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = this._clienteService.search(this.params).pipe(map(response => response.data));
            }
        });

        this.ativo.valueChanges.subscribe((query) => {
            if (typeof query === "string") {
                this.loadingSpinnerAtivos = true;
                this.params.search = query;
                this.params.tipo = "NORMAL";
                this.filteredOptionsAtivo = this._ativoService.search(
                    this.params
                );
            }
        });

        this.getAllEscritorios();
        this.getAssessores();
    }

    displayFn(cliente: ICliente): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    displayFnAtivo(ativo: IAtivo): string {
        if (ativo) {
            return ativo.sigla;
        }
        return "";
    }

    getCliente(cliente: any): void {
        this.loadingSpinner = false;
    }

    getAtivo(ativo: any): void {
        this.loadingSpinnerAtivos = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    selectEscritorio(event: any) {
        this.escritorio_id.setValue(event.value);
        this.getAssessores(event.value);
    }

    filtrar(): void {
        this.dialogRef.close({
            cliente: this.cliente.value,
            escritorio_id: this.escritorio_id.value,
            assessor_id: this.assessor_id.value,
            ativo: this.ativo.value,
        });
    }

    getAssessores(escritorio_id = "") {
        this.loadingSpinnerAssessor = true;
        this.usuarioService
            .getLista({ escritorio_id: escritorio_id })
            .subscribe(
                (resquest) => {
                    this.listAssessor = resquest.data ?? [];
                },
                (error) => {
                    this.loadingSpinnerAssessor = false;
                },
                () => {
                    this.loadingSpinnerAssessor = false;
                }
            );
    }

    getAllEscritorios() {
        this.loadingSpinnerEscritorio = true;
        this.escritorioService.getAllList({ no_paginate: true }).subscribe(
            (list) => {
                this.listEscritorios = list.data ?? [];
            },
            (error) => {
                this.loadingSpinnerEscritorio = false;
            },
            () => {
                this.loadingSpinnerEscritorio = false;
            }
        );
    }
}
